export default __webpack_public_path__ + "static/media/popup-icon-success.2110699a.svg";